import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, Form, change } from 'redux-form';
import ImageCropModalWrapper from 'appSrc/components/ImageUpload/CropModalWrapper';
import Edit from 'appSrc/components/Icons/Edit';
import TagEditor from 'appSrc/components/Tag/Editor';
import { dAPI } from 'appSrc/api';
import { PrimaryButton, DLRichTextEditor, DLAutoComplete } from 'appSrc/components/UI';
import { FormTextField, FormToggle, FormTextArea } from 'appSrc/components/UI/ReduxForm';
import defaultProfileIcon from 'appSrc/assets/img/profile.svg';
import style from './styles/style.module.css';
import CategorySelectModal from 'appSrc/AdminPanel/pages/Modals/Category/Select';
import parseUri from 'parseuri';
import io from 'socket.io-client';
import { debounce } from 'throttle-debounce';

const socketURL = process.env.REACT_APP_SOCKET_API;
const maxTimeout = 8000;

class ProductForm extends PureComponent {

    constructor( props ) {
        super( props );

        this.canSearch = true;
        this.brandName = props.initialValues.brand ? props.initialValues.brand.name : '';

        this.state = {
            lookupButtonLabel: 'Lookup!',
            selectedImage: props.initialValues.image,
            description: props.initialValues.description,
            searchValue: '',
            showResults: false,
            open: true,
            canClose: true,
            categories: props.initialValues.categories || [],
            tags: props.initialValues.tags || [],
            url: props.initialValues.url,
            brandSearch: this.brandName,
            brandOptions: [],
            brandSelected: !!props.initialValues.brand,
        };
    }
    updateTags = ( tags ) => {
        this.setState( { tags } );
        this.props.changeFieldValue( 'tags', tags );
    }
    cropFinish = ( imageData ) => {
        this.setState( {
            selectedImage: imageData,
        } );
        if( imageData != null ) {
            this.props.changeFieldValue( 'image', imageData );
        }
    }
    updateDescription = ( value ) => {
        this.setState( { description: value } );
        this.props.changeFieldValue( 'description', value );
    }
    updateCategories = ( { checked, data } ) => {
        this.categoryIds = checked;
        this.props.changeFieldValue( 'categories', data );

        this.setState( {
            categories: data,
            showCategorySelect: false,
        } );
    }
    updateUrl = ( e ) => {
        this.setState( { url: e.target.value  } );
    }
    updateBrandSearch = ( e, { value } ) => {
        this.setState( {
            brandSearch: value,
        } );
        debounce( 50, this.searchForBrand( value ) );
    }
    searchForBrand = ( name ) => {
        this.props.getBrands( {
            page: 1,
            limit: 4,
            sort: 'name,id',
            search: name || undefined,
        } )
        .then( ( brands ) => {
            this.setState( { brandOptions: brands } );
        } );
    }
    selectBrand = ( e, { result } ) => {
        var brand = {
            name: result.title.replace( /^\d+:\s/, '' ),
            id: result.value,
        };
        this.props.changeFieldValue( 'brand_id', brand.id );
        this.props.changeFieldValue( 'brand', brand );
        this.setState( { brandSearch: brand.name, brandOptions: [], brandSelected: true } );
    }
    catchKeyPress = ( e ) => {
        if( e.key == 'Enter' ) {
            e.preventDefault();
        }
    }
    submitHandler = ( values ) => {
        var updates = { product: { ...values } };
        updates.image = this.state.selectedImage;
        updates.tags = this.tagEditor.getTagResults();
        updates.categories = this.state.categories;
        this.props.onSubmit( updates );
    }
    getProductDetails( urlToTest, affiliateInfo, subAffCode ) {
        return new Promise( ( resolve, reject ) => {
            // set timeout for fetching product details
            let timeoutID = setTimeout( () => {
                reject(`Error: Product details request timed out after ${ maxTimeout } milliseconds.`);
            }, maxTimeout );

            let requestData = {
                url: urlToTest,
                parser: this.getParserName( affiliateInfo ),
                affiliateInfo: affiliateInfo,
                subAffCode: subAffCode,
            };

            let client = io.connect( socketURL );
            client.on( 'connect', function () {
                // send data to Socket.IO server
                client.emit( 'getProductDetails', requestData );
            } );
            client.on( 'getProductDetailsResponse', function ( data ) {
                // validate response from Socket.IO server
                window.clearTimeout( timeoutID );
                client.disconnect();
                resolve( data.response.result );
            } );
        } );
    }
    getParserName( affiliateInfo ) {
        if ('affiliate' in affiliateInfo && 'affiliateType' in affiliateInfo.affiliate) {
            return affiliateInfo.affiliate.affiliateType.toLowerCase();
        }
        else {
            return 'generic';
        }
    }
    lookupProduct = () => {
        this.setState( { lookupButtonLabel: 'Searching...' } );
        var uri = parseUri( this.state.url || '' );
        this.props.findAdvertiser( uri.host )
        .then( ( affiliateInfo ) => {
            var affiliateid = ( affiliateInfo.affiliate || {} ).affiliateid;

            return this.props.getSubAffiliateCode( affiliateid )
            .then( ( subAffiliateInfo ) => {
                var subAffCode = subAffiliateInfo.subAffCode || null;
                return this.getProductDetails( this.state.url, affiliateInfo, subAffCode );
            } )
            .catch( () => {
                return this.getProductDetails( this.state.url, affiliateInfo, null );
            } );
        } )
        .then( ( product ) => {
            this.setState( { lookupButtonLabel: 'Lookup!' } );
            this.setState( { ...product } );
            this.props.changeFieldValue( 'title', product.title );
            this.props.changeFieldValue( 'originalUrl', product.originalUrl );
            this.props.changeFieldValue( 'url', product.url );
            this.props.changeFieldValue( 'price', product.price );
            this.props.changeFieldValue( 'description', product.description );
            this.props.changeFieldValue( 'image', product.imageArr[0] );
            this.setState( { selectedImage: product.imageArr[0] } );
        }, ( err ) => {
            // if the request times out, log the error and show a blank product form
            console.error(err);
            this.setState( { lookupButtonLabel: 'Lookup!' } );
        } );
    }
    render() {
        const { handleSubmit } = this.props;
        const { selectedImage, brandSearch, brandOptions, categories, lookupButtonLabel } = this.state;


        const brandResults = brandOptions.map( ( brand ) => {
            return {
                title: `${ brand.id }: ${brand.name}`,
                value: brand.id,
            };
        } );
        const showBrandResults = brandResults.length > 0;


        return (
            <Form
            className={ style.individualUser }
            onSubmit={ handleSubmit( this.submitHandler ) }>
                <div className={ style.topLevel }>
                    <div className={ style.imageWrapper }>
                        <ImageCropModalWrapper
                        aspectRatio={ 1 }
                        onFinish={ this.cropFinish }>
                            <div>
                                <img src={ selectedImage || defaultProfileIcon } />
                                <span className={ style.editWrapper }><Edit style={ { display: 'inline-block' } } /></span>
                            </div>
                        </ImageCropModalWrapper>
                    </div>
                    <div className={ style.detailsWrapper }>

                        <Field
                        id="originalUrl"
                        name="originalUrl"
                        label="Original Link"
                        component={ FormTextField }
                        fullWidth
                        onChange={ this.updateUrl } />

                        <PrimaryButton
                        onClick={ () => { this.lookupProduct(); } }
                        label= { lookupButtonLabel }
                        fullWidth
                        type="button"
                        style={ { marginBottom: '45px' } }/>

                        <Field
                        id="url"
                        name="url"
                        label="Affiliate Link"
                        component={ FormTextField }
                        fullWidth/>

                        <Field
                        id="title"
                        name="title"
                        label="Title"
                        component={ FormTextField }
                        fullWidth />

                        <Field
                        id="price"
                        name="price"
                        label="Price"
                        hintText="Price"
                        component={ FormTextField }
                        fullWidth />

                        <DLRichTextEditor label="Description"
                        value={ this.state.description } onChange={ this.updateDescription } />

                        <Field
                        id="short_description"
                        name="short_description"
                        label="Short Description"
                        component={ FormTextArea }
                        fullWidth
                        style={ { marginTop: '45px' } }/>

                        <div onKeyPress={ this.catchKeyPress }>
                            <DLAutoComplete
                            value={ brandSearch }
                            label='Brand'
                            onChange={ this.updateBrandSearch }
                            onResultSelect={ this.selectBrand }
                            results={ brandResults }
                            open={ showBrandResults }
                            maxLength='40'
                            fullWidth
                            style={ { marginTop: '7px' } } />
                        </div>

                        <Field
                        id="what_text"
                        name="what_text"
                        label="What"
                        component={ FormTextArea }
                        fullWidth />

                        <Field
                        id="why_text"
                        name="why_text"
                        label="Why"
                        component={ FormTextArea }
                        fullWidth />

                        <Field
                        id="who_text"
                        name="who_text"
                        label="Who"
                        component={ FormTextArea }
                        fullWidth />

                        <TagEditor
                        label='Tags'
                        style={ { marginTop: '15px', maxWidth: '350px' } }
                        addTag={ ( tagtext ) => { return this.props.addTag( this.props.initialValues.desireid, tagtext ); } }
                        deleteTag={ ( tagtext ) => { return this.props.deleteTag( this.props.initialValues.desireid, tagtext ); } }
                        currentTags={ this.props.initialValues.tags ? this.props.initialValues.tags : [] }
                        childRef={ ( el ) => { this.tagEditor = el; } } />

                        <div className={ style.categoriesField } >
                            <div className={ style.fieldTitle }>Categories:</div>
                            <p onClick={ () => { this.setState( { showCategorySelect: true } ); } }>{ categories.map( category => category.name ).join( ', ' ) }</p>
                        </div>

                        { this.state.showCategorySelect &&
                            <CategorySelectModal initialValues={ this.props.initialValues.categories ? this.props.initialValues.categories : [] }
                            onSubmit={ this.updateCategories }
                            closeHandler={ () => { this.setState( { showCategorySelect: false } ); } } />
                        }

                        <Field
                        id='featured'
                        name='featured'
                        label='Featured'
                        component={ FormToggle }
                        style={ { marginTop: '45px' } } />

                        <Field
                        id='deactivated'
                        name='deactivated'
                        label='Deactivated'
                        component={ FormToggle }
                        style={ { marginTop: '10px' } } />

                        <PrimaryButton
                        label="Submit"
                        fullWidth
                        type="submit"
                        style={ { marginTop: '45px' } }/>
                    </div>
                </div>
            </Form>
        );
    }
}

ProductForm = reduxForm( {
    form: 'ProductForm',
} )( ProductForm );

const mapStateToProps = ( state ) => {
    return {
        listInterests: state.vars.interests,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        changeFieldValue: ( field, value ) => {
            dispatch( change( 'ProductForm', field, value ) );

        },
        addTag: ( productid, newTag ) => {
            return dAPI.post( `/desires/${ productid }/tag`, { tag: newTag } );

        },
        deleteTag: ( productid, tagtext ) => {
            return dAPI.delete( `/desires/${ productid }/tag/${ tagtext }` );

        },
        findAdvertiser: ( domain ) => {
            return dAPI.post( '/affiliates/advrtsr/search', { domain } );

        },
        getSubAffiliateCode: ( affiliateid ) => {
            return dAPI.get( `/affiliates/subaffiliateID/${ affiliateid }` )
            .catch( () => ( { subAffCode: null } ) );

        },
        getBrands: ( queryObject ) => {
            return dAPI.get( '/admin/brands', queryObject );

        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ProductForm );
